import { render } from "./LandingPage.vue?vue&type=template&id=abd8c5a4&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=abd8c5a4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ft\\Coding\\GT Designer\\gtdesigner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abd8c5a4"]])

export default __exports__